/** An edit page before there is a record to edit: loading, or why it could not be shown. */
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import { DashboardsPage } from '../../dashboards/DashboardsPage';

export interface EditorPageNoticeProps {
  message: string;
  listPath: string;
  /** The list the back link returns to, e.g. "Campaigns". */
  listLabel: string;
  /** The page title, e.g. "Edit campaign". */
  title: string;
  /** A problem rather than a wait. */
  problem?: boolean;
}

export function EditorPageNotice({
  message,
  listPath,
  listLabel,
  title,
  problem = false,
}: EditorPageNoticeProps) {
  return (
    <DashboardsPage
      header={
        <header style={{ padding: '22px 32px 14px' }}>
          <Link
            to={listPath}
            className="nb-eyebrow"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 4,
              color: 'var(--nb-muted)',
            }}
          >
            <ChevronLeft size={12} aria-hidden />
            {listLabel}
          </Link>
          <h1
            className="nb-display"
            style={{ margin: '4px 0 0', fontSize: 30, color: 'var(--nb-bark-dark)' }}
          >
            {title}
          </h1>
        </header>
      }
    >
      <div
        role={problem ? 'alert' : 'status'}
        className="nb-card"
        style={{ fontSize: 13, color: problem ? 'var(--nb-warn)' : 'var(--nb-subtle)' }}
      >
        {message}
      </div>
    </DashboardsPage>
  );
}
